import { ReactNode } from "react";
import { cn } from "../../ClassName";

interface Props {
  className?: string;
  children?: ReactNode;
  id?: string;
}

const H5_BASE_STYLING =
  "tw-font-sans tw-font-bold tw-tracking-[-.03em] tw-text-[20px]";

export const H5_DEFAULT_STYLING = `${H5_BASE_STYLING} tw-text-blue-dark-1`;

export function H5(props: Props) {
  const defaultColor = props.className?.includes("tw-text-")
    ? ""
    : " tw-text-blue-dark-1";
  return (
    <h5
      className={cn(H5_BASE_STYLING + defaultColor, props.className)}
      id={props.id}
    >
      {props.children}
    </h5>
  );
}
